<template>
    <div class="filter">
        <form class="content border">
            <div class="filter_item">
                <div class="filter_label filter_slider_open filter-price" >
                    Цена
                    <div class="filter_hide">
                        <div class="filter_slider_wrapper">
                            <div class="filter_slider_status">
                                <div class="filter_slider_min">от <span>{{ priceFilter.min }}</span></div>
                                <div class="filter_slider_max">до <span>{{ priceFilter.max }}</span></div>
                            </div>
                            <input
                                @change="changeFilter"
                                name="price"
                                type="text"
                                class="filter_slider_base"
                                value=""
                                :data-slider-min="priceFilter.min"
                                :data-slider-max="priceFilter.max"
                                data-slider-step="1"
                                :data-slider-value="filterPriceRange"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="filter_item" v-if="brands.length > 1" style="margin-left: 20px;">
                <div class="filter_label">
                    Бренды <img src="/cloudmill/images/str_down.svg" alt="">
                    <select v-select2 class="filter_select" v-model="filterBrand" @change="changeFilter"
                            :multiple="true">
                        <option :value="brand" v-for="brand in brands" :key="brand" :selected="brand==filterBrand">
                            {{ brand }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="filter_item" v-for="filter in filteredFilters" :key="filter.type.id">
                <div class="filter_label">
                    {{ filter.type.name }} <img src="/cloudmill/images/str_down.svg" alt="">
                    <!-- :multiple="filter.possible_values.length>2" -->
                    <select v-select2 class="filter_select" :filter-id="filter.type.id"
                            v-model="filterTools[filter.type.id]" multiple @change="changeFilter">
                        <option :value="pval" v-for="pval in filter.possible_values" :key="pval">{{ pval }}</option>
                    </select>
                </div>
            </div>
          <div class="filter_item" v-if="brands.length > 1" style="margin-left: 20px;">
            <div class="filter_label">
              <div class=" def-form-checkbox">
                <div class="radio-custom" @click="inStockOnly=!inStockOnly; applyFilter()" :class="{'active' : inStockOnly}"></div>
                <label style="font-size: 20px;">Только в наличии</label>
              </div>

            </div>
          </div>


          <a href="" class="filter_showAll"
            >Все фильтры <i class="icon-filter"></i
            ></a>
            <a href="" class="filter_close"
            >Закрыть <i class="icon-close"></i
            ></a>
            <div class="filter_buts">
                <button type="button" class="btn btn-gray" @click="clearFilters">Сбросить все</button>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    name: 'ProductFilters',
    props: ['filters', 'brands', 'priceFilter'],
    data() {
        return {
            filterBrand: [],
            filterTools: {},
            filterPrice: [],
            inStockOnly: false,
            filterPriceRange: JSON.stringify([this.priceFilter.min, this.priceFilter.max])
        }
    },
    methods: {
        changeFilter(event) {
            if (window.$(event.target).attr('filter-id')) {
                this.filterTools[window.$(event.target).attr('filter-id')] = window.$(event.target).val()
            }
            this.applyFilter()
            // this.$log(window.$(event.target).attr('filter-id'), this.filterTools[window.$(event.target).attr('filter-id')])
        },
        changeSlider(event) {
            this.filterPrice = event.value
            this.applyFilter()
        },
        applyFilter() {
            this.$emit('apply-filters', {
                'price': this.filterPrice,
                'brand': this.filterBrand,
                'other': this.filterTools,
                'in_stock_only' : this.inStockOnly
            });
            // this.$log(window.$(event.target).attr('filter-id'), 'apply');
        },
        clearFilters() {
            this.filters.forEach((filter) => {
                this.filterTools[filter.type.id] = []
            });
            this.filterBrand = []
            this.filterPrice = []
            this.$log('Filter cleared');
        },
        setParams(params) {
            if (params && params.price) {
                this.filterPriceRange = params.price
            } else {
                this.filterPriceRange = JSON.stringify([this.priceFilter.min, this.priceFilter.max])
            }
            if (params && params.brand) {
                this.filterBrand = params.brand
            } else {
                this.filterBrand = []
            }
            if (params && params.other) {
                for (const [key, value] of Object.entries(params.other)) {
                    this.filterTools[key] = value
                }
            } else {
                this.filters.forEach((filter) => {
                    this.filterTools[filter.type.id] = []
                });
            }
        },

    },
    computed: {
        dataSliderValue() {
            return JSON.stringify([this.priceFilter.min, this.priceFilter.max]);
        },
        filteredFilters() {
            return this.filters.filter(filter => filter.possible_values.length > 1)
        }
    },
    created: function () {
        console.log(this.filters)
        this.filters.forEach((filter) => {
            this.filterTools[filter.type.id] = []
        });
        // this.parseUri()
    },
    mounted() {
        window.$(document).on("slideStop", ".filter_slider_base", this.changeSlider)
        window.$(document).on("click", ".select2_set", this.applyFilter)
        window.$(document).on("click", ".select2_clear", this.clearFilters)
    },
    destroyed() {
        window.$(document).off("slide", ".filter_slider_base")
        window.$(document).off("click", ".select2_set")
        window.$(document).off("click", ".select2_clear")
    }
}
</script>

<style scoped>
  @media (min-width: 950px) {
    .filter-price {
      margin-left: 20px;
      margin-right: 15px;
    }
  }

</style>